import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'

import { graphql } from '~/gql'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const brandTabulationQueryDataFragment = graphql(`
  fragment TimeSeriesAnalysisPage_BrandTabulationQueryData on CountSurveyGroupBrandResult {
    surveyGroupBrandId
    results {
      surveyId
      segmentCount {
        segmentNumber
        count
      }
    }
  }
`)

const questionTabulationQueryDataFragment = graphql(`
  fragment TimeSeriesAnalysisPage_QuestionTabulationQueryData on CountSurveyGroupQuestionResult {
    surveyGroupQuestionId
    answers {
      answerOption {
        option
        text
      }
      counts {
        surveyId
        count
      }
    }
  }
`)

const customerAttributeTabulationQueryDataFragment = graphql(`
  fragment TimeSeriesAnalysisPage_CustomerAttributeTabulationQueryData on CountSurveyGroupCustomerAttributesInSurveyResult {
    surveyId
    results {
      byCustomerAttributeId
      result {
        totalCount
      }
    }
  }
`)

type TabulationQueryData = {
  brands: ResultOf<typeof brandTabulationQueryDataFragment>[] | null
  questions: ResultOf<typeof questionTabulationQueryDataFragment>[] | null
  customerAttributes:
    ResultOf<typeof customerAttributeTabulationQueryDataFragment>[] | null
}
export const tabulationQueryDataAtom =
  atomWithReset<TabulationQueryData | null>(null)
